import React, { Component } from 'react'

class Collapsible extends Component {
  constructor (props) {
    super(props)
    this.state = {
      open: this.props.open
    }
    this.togglePanel = this.togglePanel.bind(this)
    this.openPanel = this.openPanel.bind(this)
  }

  togglePanel (e) {
    this.setState({ open: !this.state.open })
  }

  openPanel (e) {
    this.setState({ open: true })
  }

  render () {
    return (<div>
      {this.props.title !== ''
        ? <h4 onClick={(e) => this.togglePanel(e)} className='table-heading collapsible-heading' id={'h4FilterHeader' + this.props.id}>
          <div className={this.props.titleClassName}>
            <div>
              {this.props.title}
              {this.state.open ? <div id='chevron-arrow-bottom' className='chevron-bottom' /> : <div id='chevron-arrow-right' />}
            </div>
          </div>
        </h4>
        : <></>}
      {this.state.open ? (
        <div className='content'>
          {this.props.children}
        </div>
      ) : (<>{this.props.collapsed}</>)}
    </div>)
  }
}

export default Collapsible
